import {
  Typography,
  Box,
  CircularProgress,
  Checkbox,
  Chip,
  List,
  ListItem,
  ListItemText,
  Tooltip,
} from '@mui/material';
import { countDecimals } from '../../utils/parsing';
import { MISSING_VALUE, LIST_DELIMITER, percentileColor } from './data-table';

const TRUNCATION_LIMIT = 18;
export const CellList = (values) => (
  <List>
    {(Array.isArray(values) ? values : values?.split(LIST_DELIMITER))?.map((v) => (
      <ListItem dense key={v}>
        {v?.length > TRUNCATION_LIMIT ? (
          <Tooltip title={v}>
            <ListItemText primary={`${v.substr(0, TRUNCATION_LIMIT)}...`} />
          </Tooltip>
        ) : (
          <ListItemText primary={v} />
        )}
      </ListItem>
    ))}
  </List>
);

export const DateCell = ({ cell }) => {
  const value = cell.getValue();
  if (value === null || value === MISSING_VALUE) return null;
  return (
    <Tooltip title={`Time are in ${Intl.DateTimeFormat().resolvedOptions().timeZone}`}>
      {value?.toLocaleDateString()} {value?.toLocaleTimeString()}
    </Tooltip>
  );
};

export function PrecisionCell(cell, precision) {
  const value = cell.getValue();
  const number = Number.parseFloat(value);
  if (!Number.isNaN(number) && countDecimals(number) > 2)
    return <Tooltip title={number}>{number.toFixed(precision)}...</Tooltip>;
  return value;
}

export const TooltipHeader = ({ tooltip, content }) => (
  <Tooltip title={tooltip} placement="top">
    {content}
  </Tooltip>
);

export const PredictionsChip = ({ color, predictions }) => {
  if (predictions) {
    let label = `${(predictions.min * 100.0).toPrecision(3)}%`;
    if (predictions.min !== predictions.max)
      label = `${(predictions.min * 100.0).toPrecision(3)}% - ${(predictions.max * 100.0).toPrecision(3)}%`;
    return <Chip color={color} label={label} />;
  }
  return null;
};

export const CheckboxFilter = ({ column }) => (
  <Checkbox
    sx={{ padding: '0px' }}
    color={column.getFilterValue() === 'true' ? 'success' : 'secondary'}
    indeterminate={column.getFilterValue() === undefined}
    checked={column.getFilterValue() === 'true'}
    onChange={(event) =>
      column.setFilterValue(
        column.getFilterValue() === 'false' ? undefined : event.target.checked.toString()
      )
    }
  />
);

export const PercentageCell = ({ cell }) => {
  const value = cell.getValue();
  return (
    <Box sx={{ position: 'relative', display: 'inline-flex' }}>
      <CircularProgress
        variant="determinate"
        color={percentileColor(value)}
        value={value <= 0 || value === MISSING_VALUE ? 100 : value}
      />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: 'absolute',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography variant="caption" component="div" color="text.secondary">
          {value < 0 || value === MISSING_VALUE ? '-' : `${Math.floor(value)}%`}
        </Typography>
      </Box>
    </Box>
  );
};
